module.exports = __webpack_public_path__ + "img/short03-57s-preview.2a561992.jpg";